import { render, staticRenderFns } from "./MaterialDeliveryCardList.vue?vue&type=template&id=6321c74e&scoped=true"
import script from "./MaterialDeliveryCardList.vue?vue&type=script&lang=js"
export * from "./MaterialDeliveryCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6321c74e",
  null
  
)

/* custom blocks */
import block0 from "@/components/CoreMaterial/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FCoreMaterial%2FMaterialDelivery%2FMaterialDeliveryCardList.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports